import { useGetPatientHasMobileAndCoachAccess } from './useGetPatientHasMobileAndCoachAccess';
import { useMomentumPilotPatientAccessQuery } from './useMomentumPilotPatientAccessQuery';

export const WEB_CLIENT_SET_INTENTIONS_KEY = 'web-client-set-intentions';

/**
 * Hook to check if a patient has access to web client intentions feature.
 * Combines pilot access check for 'web-client-set-intentions' and mobile/coach access check.
 *
 * @param patientShortId - The patient's short ID
 * @param skip - Whether to skip the query (e.g., for non-web platforms)
 * @returns Object containing access status and loading state
 */
export function usePatientWebIntentionsAccess(patientShortId: string, { skip }: { skip?: boolean } = {}) {
  const shouldSkip = Boolean(!patientShortId || skip);

  const { pilotAccess, loading: pilotAccessLoading } = useMomentumPilotPatientAccessQuery({
    patientShortId,
    key: WEB_CLIENT_SET_INTENTIONS_KEY,
    shouldSkipAppVersionCheck: true,
    skip: shouldSkip,
  });

  const { patientHasAccess, loading: patientAccessLoading } = useGetPatientHasMobileAndCoachAccess(patientShortId, {
    skip: shouldSkip,
  });

  if (shouldSkip) {
    return {
      hasAccess: false,
      isLoading: false,
    };
  }

  return {
    hasAccess: !!pilotAccess?.enabled && !!patientHasAccess,
    isLoading: pilotAccessLoading || patientAccessLoading,
  };
}
